import { useState } from "react"

export const useGlobalStates = () => {
    const [showForm, setShowForm] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')

    const [showModalDeposit, setShowModalDeposit] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [showTypeForm, setshowTypeForm] = useState('None')

    const [stepApplilication, setStepApplilication] = useState(0)

    // ✅ para navegación entre tabla e imágenes
    const [showSection, setShowSection] = useState('HOME')
    const [imagesCurrentIndex, setImagesCurrentIndex] = useState(0)

    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        stepApplilication, setStepApplilication,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        showTypeForm, setshowTypeForm,

        // ✅ nuevos
        showSection, setShowSection,
        imagesCurrentIndex, setImagesCurrentIndex,
    })
}
